import React from 'react';
import DiffMatchPatch from 'diff-match-patch';
import axios from 'axios';

const getCurrentMenuInfo = (menuInfo, menu_no) => {
    ////console.log("received menuInfo is: ",menuInfo);
    ////console.log("received menu_no is: ",menu_no);
    let currentMenuInfo;
    if(menuInfo === null){return null;}
    for (let i = 0; i < menuInfo.length; i++) {
        if (menuInfo[i].sub[`${menu_no}`]) {
            currentMenuInfo = menuInfo[i].sub[`${menu_no}`];
            ////console.log("return currentMenu is:",currentMenuInfo);

            return currentMenuInfo;
        }
        // //console.log(menuInfo[i].sub);
        //return (menuInfo[i]);
    }

    //console.log("return current menu is null");
    //return menuInfo[0];
    return null;
};

const brTagActivator = (input) => {
    if(input === null){
        return null;
    }

    let arr = input.split(/<br\s*\/?>/i);
    //let reducer = (el, a) => el.concat(a, <br />);
    return arr.map((str, i) => {
        if(i === (arr.length - 1)) {
            return (<span key={`brtagact-${i}`}>{str}</span>)
        }
        return (<span key={`brtagact-${i}`}>{str}<br /> </span>)
    });

    //return arr.reduce((el, a) => el.concat(a, <br/>),[]);

};

const strongTagChanger = (input) => {
    if(input == null){
        return null;
    }

    let output = input.replace(/</g,`&`);
    output = output.replace(/>/g,'_');
    output = output.replace(/&/g,'<strong>');
    output = output.replace(/_/g,'</strong>');
    //return arr.reduce((el, a) => el.concat(a, <br/>),[]);

    //console.log("strong output:",output);
    return output;

};


const brTagRemover = (input) => {
    if(input === null){
        return null;
    }

    let arr = input.split(/<br\s*\/?>/i);
    //let reducer = (el, a) => el.concat(a, <br />);
    return arr.map((str, i) => {return (<span key={i}>{str}</span>)});

    //return arr.reduce((el, a) => el.concat(a, <br/>),[]);

};

const NUMBER_WORDS = {
    "0": "zero",
    "1": "one",
    "2": "two",
    "3": "three",
    "4": "four",
    "5": "five",
    "6": "six",
    "7": "seven",
    "8": "eight",
    "9": "nine",
    "10": "ten",
    "11": "eleven",
    "12": "twelve",
    "13": "thirteen",
    "14": "fourteen",
    "15": "fifteen",
    "16": "sixteen",
    "17": "seventeen",
    "18": "eighteen",
    "19": "nineteen",
    "20": "twenty",
    "21": "twenty one",
    "22": "twenty two",
    "23": "twenty three",
    "24": "twenty four",
    "25": "twenty five",
    "26": "twenty six",
    "27": "twenty seven",
    "28": "twenty eight",
    "29": "twenty nine",
    "30": "thirty",
    "40": "forty",
    "50": "fifty",
    "60": "sixty",
    "70": "seventy",
    "80": "eighty",
    "90": "ninety",
    "100": "one hundred",
    "630": "six thirty",
};

const TENS_WORDS = {
    "2": "twenty",
    "3": "thirty",
    "4": "forty",
    "5": "fifty",
    "6": "sixty",
    "7": "seventy",
    "8": "eighty",
    "9": "ninety",
};

const ORDINAL_WORDS = {
    "1st": "first",
    "2nd": "second",
    "3rd": "third",
    "4th": "fourth",
    "5th": "fifth",
    "6th": "sixth",
    "7th": "seventh",
    "8th": "eighth",
    "9th": "ninth",
    "10th": "tenth",
    "11th": "eleventh",
    "12th": "twelfth",
    "13th": "thirteenth",
    "14th": "fourteenth",
    "15th": "fifteenth",
    "16th": "sixteenth",
    "17th": "seventeenth",
    "18th": "eighteenth",
    "19th": "nineteenth",
    "20th": "twentieth",
    "21st": "twenty first",
    "22nd": "twenty second",
    "23rd": "twenty third",
    "24th": "twenty fourth",
    "25th": "twenty fifth",
    "30th": "thirtieth",
};

const CONTRACTIONS = {
    "i'm": "i am",
    "you're": "you are",
    "he's": "he is",
    "she's": "she is",
    "it's": "it is",
    "we're": "we are",
    "they're": "they are",
    "that's": "that is",
    "what's": "what is",
    "where's": "where is",
    "who's": "who is",
    "can't": "cannot",
    "won't": "will not",
    "don't": "do not",
    "doesn't": "does not",
    "didn't": "did not",
    "isn't": "is not",
    "aren't": "are not",
    "wasn't": "was not",
    "weren't": "were not",
    "i'll": "i will",
    "you'll": "you will",
    "i've": "i have",
    "you've": "you have",
};

const replaceMappedWords = (input, map) => {
    return Object.keys(map).reduce((output, key) => {
        return output.replace(new RegExp(`\\b${key}\\b`, "gi"), map[key]);
    }, input);
};

const numberToWords = (value) => {
    const normalizedValue = String(value).replace(/^0+(\d)/, "$1");

    if(NUMBER_WORDS[normalizedValue]) {
        return NUMBER_WORDS[normalizedValue];
    }

    if(/^[2-9][1-9]$/.test(normalizedValue)) {
        return `${TENS_WORDS[normalizedValue.charAt(0)]} ${NUMBER_WORDS[normalizedValue.charAt(1)]}`;
    }

    return normalizedValue;
};

const normalizeSpeechText = (input) => {
    if(input === null || input === undefined) {
        return "";
    }

    let output = String(input)
        .toLowerCase()
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, " ")
        .replace(/[’‘`]/g, "'")
        .replace(/&/g, " and ")
        .replace(/\+/g, " plus ")
        .replace(/=/g, " is ")
        .replace(/\*/g, " times ")
        .replace(/\//g, " divided by ");

    output = replaceMappedWords(output, CONTRACTIONS);
    output = replaceMappedWords(output, ORDINAL_WORDS);
    output = output.replace(/\b\d+\b/g, numberToWords);

    return output
        .replace(/-/g, " ")
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
};

const normalizeSpeechTextForDiff = (input) => {
    const normalized = normalizeSpeechText(input);
    const matches = normalized.match(/[a-z0-9]/g);

    return matches ? matches.join("") : "";
};

const isShortSpeechOriginal = (original) => {
    return normalizeSpeechTextForDiff(original).length <= 4;
};

const isKidsMode = () => {
    return typeof window !== "undefined" && window.serverData && window.serverData.user_kind === "K";
};

const KidsMinimumScore = 85;
const shortWordMinimumScore = 85;
const DefaultBaseScore = 60;
const FailScore = 70;

const calculateScore = (result, original) => { //result = 원본 콘텐츠의 lower case 버전
   // //console.log("result: ",result);
   // //console.log("original: ",original);
    const isKids = isKidsMode();

    //"##ERROR" 코드로 들어오는 경우, 점수를 무조건 C정도로 출력시킴
    if(result === "##ERROR") {
        return FailScore;
    }

    if(result === "" || result == null) {
        console.warn("결과값이 없습니다.");
        if(normalizeSpeechTextForDiff(original).length <= 4) {
            return isKids ? Math.max(KidsMinimumScore, shortWordMinimumScore) : shortWordMinimumScore;
        }
        return isKids ? KidsMinimumScore : DefaultBaseScore;
    }

    if(!isKids && normalizeSpeechTextForDiff(result) === "") {
        console.warn("결과값에 알파벳 또는 숫자 문자열이 없습니다.");
        return FailScore;
    }

    result = retouchResult(result, original); //특정 단어를 보정함
    
    let correct = 0;
    let incorrect = 0;
    let diff;
    const DIFF_DELETE = -1;
    const DIFF_INSERT = 1;
    const DIFF_EQUAL = 0;
    const dmp = new DiffMatchPatch();
    // _diff(original, userResult){
    //     //console.log(userResult);
    //     const dmp = new DiffMatchPatch();
    //     const diff = dmp.diff_main(original.toLowerCase(), userResult.toLowerCase());
    //
    //     return diff;
    //     //return {__html:dmp.diff_prettyHtml(diff)};    // }

    if(typeof result !== "string" || typeof original !== "string"){
        console.warn("인자의 Type 이 올바르지 않거나, 인자값이 존재하지 않습니다.");
        return isKids ? KidsMinimumScore : DefaultBaseScore;
    }

    let trimmedOriginal = normalizeSpeechTextForDiff(original);
   // //console.log(`trimmedOriginal=${trimmedOriginal}`);
    let trimmedResult = normalizeSpeechTextForDiff(result);
    ////console.log(`trimmedResult=${trimmedResult}`);
    if(trimmedOriginal)
    diff = dmp.diff_main(trimmedOriginal, trimmedResult);
    ////console.log(diff);

    for(let i = 0 ; i < diff.length; i ++){
        let op = diff[i][0];
        switch(op){
            case DIFF_INSERT:
                incorrect += diff[i][1].length;
                break;
            case DIFF_EQUAL:
                correct += diff[i][1].length;
                break;
            case DIFF_DELETE:
                incorrect += diff[i][1].length;
                break;
            default:
                break;
        }

    }

    ////console.log(`Correct: ${correct}, Incorrect: ${incorrect}`);
    //return Math.ceil(20 + ((correct / (incorrect + correct)) * 80));
    let t = correct / (incorrect + correct);
    let baseScore = trimmedOriginal.length <= 4 ? shortWordMinimumScore : DefaultBaseScore;
    if (isKids)
        baseScore = Math.max(baseScore, KidsMinimumScore);
    let score = Math.ceil(t*(100 - baseScore));
    //let score = Math.floor(-(t*(t-2))*100);
    // console.log(`${result}와 ${original}에 의한 점수는 ${score+60}`);
    score = score + baseScore;
    score = Math.max(score, baseScore);
    return score;
};

const getABCScore = (score) => {
    if (score < FailScore) {
        return "F";
    } else if (score >= FailScore && score < 80) {
        return "C";
    } else if (score >= 80 && score < 84) {
        return "C+";
    } else if (score >= 84 && score < 88) {
        return "B";
    } else if (score >= 88 && score < 92) {
        return "B+";
    } else if (score >= 92 && score < 98) {
        return "A";
    } else if (score >= 98) {
        return "A+";
    }

    return null;
};

const getStorytellingABCScore = (score) => {
    if (score < FailScore) {
        return "F";
    } else if (score >= FailScore && score < 80) {
        return "C+";
    } else if (score >= 80 && score < 86) {
        return "B";
    } else if (score >= 86 && score < 91) {
        return "B+";
    } else if (score >= 91 && score < 95) {
        return "A";
    } else if (score >= 95) {
        return "A+";
    }

    return null;
};

const getTodayDate = () => {
    let today = new Date();
    let options = {weekday: 'long', year: 'numeric', month:'long', day:'numeric'};
    return today.toLocaleDateString('ko-KR', options);
};

const retouchResultNumber = (result) => {
    result = result.toLowerCase();
    // result.replace("1 + 1", "one plus one");
    // result.replace("1 - 1", "one minus one");
    // result.replace("2 4 6 8 and 10", "two, four, six, eight, and ten.");
    // result.replace("1 3 5 7 and 9", "one, three, five, seven, and nine.");
    // result.replace("2 * 1", "two times one");
    // result.replace("= 2", "is two.");
    // result.replace("2 * 2", "two times two");
    // result.replace("= 4", "is four.");
    // result.replace("2 * 3", "two times three");
    // result.replace("= 6", "is six.");
    // result.replace("2 * 4", "two times four");
    // result.replace("= 8", "is eight.");
    // result.replace("3 * 3", "three times three");
    // result.replace("9", "nine.");
    // result.replace("3 / 3", "three divided by three");
    // result.replace("1", "one");
    result = result.replace(/10/gi, "ten").replace(/1/gi, "one").replace(/2/gi, "two").replace(/3/gi, "three").replace(/4/gi, "four").replace(/5/gi, "five")
        .replace(/6/gi, "six").replace(/7/gi, "seven").replace(/8/gi, "eight").replace(/9/gi, "nine").replace(/\+/gi, "plus").replace(/-/gi, "minus")
        .replace(/=/gi, "is").replace(/\//gi, "divided by").replace(/\*/gi, "times");
    // result.replace("1", "one");
    // result.replace("2", "two");
    // result.replace("3", "three");
    // result.replace(/4/gi, "four")
    // result.replace(/5/gi, "five")
    // result.replace(/6/gi, "six")
    // result.replace(/7/gi, "seven")
    // result.replace(/8/gi, "eight")
    // result.replace(/9/gi, "nine")
    // result.replace(/\+/gi, "plus");
    // result.replace(/-/gi, "minus");
    // result.replace(/=/gi, "is");
    // result.replace(/\//gi, "divided by");
    // result.replace("1", "one");
    // result.replace("1", "one");

    return result;
}

const RETOUCH_RESULT_CASES = {
    "is": ["he is", "ease", "east", "yes"],
    "too": ["2", "two", "to"],
    "to": ["2", "two", "too"],
    "two": ["2", "to", "too"],
    "one": ["1", "won"],
    "oh i see": ["yc", "ic", "oic", "oh i c"],
    "fourth": ["4th", "four"],
    "thirsty": ["30", "thirty"],
    "knot": ["not", "know", "no"],
    "grin": ["green"],
    "tie": ["thai"],
    "wheat": ["wait"],
    "mill": ["meal", "men", "mirror", "meow"],
    "duck": ["talk"],
    "nine": ["9"],
    "seven": ["7"],
    "eight": ["8", "hey", "ate"],
    "twelve": ["12"],
    "forty two": ["42"],
    "forty": ["40"],
    "ten": ["10"],
    "five": ["5"],
    "four": ["4", "for"],
    "thirty": ["30"],
    "six thirty": ["630"],
    "nineteenth": ["19th"],
    "seventh": ["7th"],
    "twenty second": ["22nd"],
    "fifth": ["5th"],
    "twenty": ["20"],
    "forty five": ["45"],
    "twenty five": ["25"],
    "fifty": ["50"],
    "eleven": ["11"],
    "bee": ["b", "be"],
    "day": ["they", "hey"],
    "go": ["call", "cool"],
    "see": ["c", "sea"],
    "sea": ["c", "see"],
    "hear": ["here"],
    "here": ["hear"],
    "write": ["right"],
    "right": ["write"],
    "eye": ["i"],
};

//특정 점수가 잘 안나오는 단어들을 보정하는 함수
const retouchResult = (result, original) => {
    const normalizedOriginal = normalizeSpeechText(original);
    const normalizedResult = normalizeSpeechText(result);
    const acceptedResults = RETOUCH_RESULT_CASES[normalizedOriginal];

    if(acceptedResults && acceptedResults.map(normalizeSpeechText).includes(normalizedResult)) {
        return normalizedOriginal;
    }

    return String(result).toLowerCase();

};

const retouchOriginal = (original) => {



}

const uploadScore = (apiUrl, score, attendIdx, menu_no, tryCount, classType) => {
    //console.log("Upload Score: ",score);
    let device_from = isMobile ? isIOS ? "I" : "W" : "C"; //모바일이면 W, PC면 C, iOS면 I

    if(typeof score !== "number") {
        score = 0;
    }

    if(classType === "A"){ //관리자 점수기록 X
        //console.log("관리자는 점수기록을 하지 않습니다.");
        return;
    }

    // let device_from = isMobile ? "M" : "P";


    //console.log(`점수 업로드 시도. score = ${score}, attendIdx = ${attendIdx}, menu_no = ${menu_no}, tryCount = ${tryCount}. url is: ${apiUrl}/class/lesson/score/g/${attendIdx}/${menu_no}/${score}/${device_from}`);

    //무료체험 점수 기록
    if(classType === "F"){

        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/free/lesson/score/g/${attendIdx}/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''),
            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            console.log("점수 기록 성공.", res);

        }).catch(err => {
            console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패
        }).then(() => {
            //에러 발견시, 콜백

        });

    } else if (classType === "A"){
        //
        // Promise.all([axios({
        //         method: 'post',
        //         url: `${apiUrl}/class/lesson/score/g/1/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''),
        //     }
        // )]).then(([res]) => {
        //     //점수 기록 업로드 성공
        //     //console.log("점수 기록 성공.", res);
        //
        // }).catch(err => {
        //     //console.log("에러 발견", err);
        //     //메뉴 넘버 업데이트 실패
        //     console.warn(err);
        //     alert("알수 없는 이유로 점수 등록에 실패 하였습니다. 다시 테스트해주세요. 문제가 지속되면 원격 지원센터로 문의 바랍니다.");
        // }).then(() => {
        //     //에러 발견시, 콜백
        //
        // });
    } else {
        console.log("Upload Score to: ",`${apiUrl}/class/lesson/score/g/${attendIdx}/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''));
        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/class/lesson/score/g/${attendIdx}/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''),
            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            //console.log("점수 기록 성공.", res);

        }).catch(err => {
            //console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패
            console.warn(err);
            alert("알수 없는 이유로 점수 등록에 실패 하였습니다. 다시 테스트해주세요. 문제가 지속되면 원격 지원센터로 문의 바랍니다.");
        }).then(() => {
            //에러 발견시, 콜백

        });
    }
};

const uploadScoreAl = (apiUrl, score, attendIdx, menu_no, tryCount, classType) => {
    // let device_from = isMobile ? "M" : "P";
    let device_from = isMobile ? isIOS ? "I" : "W" : "C"; //모바일이면 W, PC면 C, iOS면 I

    if(typeof score !== "number") {
        score = 0;
    }

    //관리자 점수기록 X
    if(classType === "A"){
        return;
    }



    //응용학습 무료체험 점수 기록
    if(classType === "F") {
        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/free/lesson/score/g/${attendIdx}/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''),
            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            //console.log("점수 기록 성공.", res);

        }).catch(err => {
            //console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패
        }).then(() => {
            //에러 발견시, 콜백
        });

    } else if(classType === "A"){



    //응용학습 점수기록
    } else {
        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/class/lesson/score/g/al/${attendIdx}/${menu_no}/${score}/${device_from}`.replace(/\s/g, ''),
            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            //console.log("점수 기록 성공.", res);


        }).catch(err => {
            //console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패
            console.warn(err);
            alert("알수 없는 이유로 점수 등록에 실패 하였습니다. 다시 테스트해주세요. 문제가 지속되면 원격 지원센터로 문의 바랍니다.");

        }).then(() => {
            //에러 발견시, 콜백
        });
    }

};


//answer type = 'T' or 'G'
const uploadAnswerAl = (apiUrl, answer, attendIdx, menu_no, tryCount,answer_type, classType) => {
    // let device_from = isMobile ? "M" : "P";
    let device_from = isMobile ? isIOS ? "I" : "W" : "C"; //모바일이면 W, PC면 C, iOS면 I


    //관리자 점수기록 X
    if(classType === "A"){
        return;
    }


    //응용학습 무료체험 Answer점수 기록
    if(classType === "F") {
        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/free/lesson/answer/al/${attendIdx}/${menu_no}/${device_from}/${answer_type}`.replace(/\s/g, ''),
                data: {
                    answer
                },

            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            //console.log("점수 기록 성공.", res);

        }).catch(err => {
            //console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패
        }).then(() => {
            //에러 발견시, 콜백
        });

    } else if(classType === "A"){



    //응용학습 Answer 점수기록
    } else {
        Promise.all([axios({
                method: 'post',
                url: `${apiUrl}/class/lesson/answer/al/${attendIdx}/${menu_no}/${device_from}/${answer_type}`.replace(/\s/g, ''),
                data: {
                    answer
                }

            }
        )]).then(([res]) => {
            //점수 기록 업로드 성공
            //console.log("점수 기록 성공.", res);

        }).catch(err => {
            //console.log("에러 발견", err);
            //메뉴 넘버 업데이트 실패

            console.warn(err);
            alert("알수 없는 이유로 점수 등록에 실패 하였습니다. 다시 테스트해주세요. 문제가 지속되면 원격 지원센터로 문의 바랍니다.");
        }).then(() => {
            //에러 발견시, 콜백
        });
    }


};
//
//
// const reportEndLesson = (apiUrl, attendIdx) => {
//     //console.log("report end lesson called!");
//
//     Promise.all([axios({
//             method: 'put',
//             url: `${apiUrl}/class/lesson/end/${attendIdx}`.replace(/\s/g, ''),
//         }
//     )]).then(([res]) => {
//         //수강종료처리 완료
//         //console.log("수강 완료 처리 성공.", res);
//
//     }).catch(err => {
//         //console.log("에러 발견", err);
//         //메뉴 넘버 업데이트 실패
//     }).then(() => {
//         //에러 발견시, 콜백
//     });
//
// };

const updateStdLesson = (apiUrl, student_idx, nextStdLesson) => {
    //console.log("update std lesson called!");
    if(nextStdLesson > 340){
        return;
    }


    Promise.all([axios({
            method: 'put',
            url: `${apiUrl}/class/lesson/std/${student_idx}/${nextStdLesson}`.replace(/\s/g, ''),
        }
    )]).then(([res]) => {
        //std_lesson변경완료
        //console.log("std_lesson변경완료 성공.", res);

    }).catch(err => {
        //console.log("에러 발견", err);
        //메뉴 넘버 업데이트 실패
    }).then(() => {
        //에러 발견시, 콜백
    });
};


const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// const isMobile = true;
const isIOS = /iPhone|iPad/i.test(navigator.userAgent);
// const isIOS = true;



const updateMenuNo = (apiUrl, menuNo, activeMenuNo, step_code, group_no, attend_idx) => {
    Promise.all([axios({
            method: 'get',
            url: `${apiUrl}/class/menu/next/${activeMenuNo}/${step_code}/${group_no}`.replace(/\s/g, ''),
        }
    )]).then(([res]) => {
        //다음 메뉴 넘버 조회 성공.
        //let nextMenuNo = res.data.recordset[0].menu_no;
        ////console.log("res.data.recordset[0] = ",res.data.recordset[0]);
        if(res.data.recordset[0] === null || res.data.recordset[0] === undefined){ //res.data.recordset[0] == null
            ///////다음 메뉴 없으면 menu_no를 60으로 변경
            Promise.all([axios({
                    method: 'put',
                    url: `${apiUrl}/class/menu/${attend_idx}/60`.replace(/\s/g, ''),
                }
            )]).then(([res2]) => {
                //메뉴 넘버 업데이트 성공.
                //console.log("res2:",res2);
            }).catch(err => {
                //console.log("에러 발견", err);
                //메뉴 넘버 업데이트 실패
            }).then(() => {
                //에러 발견시, 콜백

            });

        }else if(res.data.recordset[0].menu_no > menuNo){ //다음 메뉴 넘버가 더 크면, UPDATE
            Promise.all([axios({
                    method: 'put',
                    url: `${apiUrl}/class/menu/${attend_idx}/${res.data.recordset[0].menu_no}`.replace(/\s/g, ''),
                }
            )]).then(([res2]) => {
                //메뉴 넘버 업데이트 성공.
                //console.log("res2:",res2);
            }).catch(err => {
                //console.log("에러 발견", err);
                //메뉴 넘버 업데이트 실패
            }).then(() => {
                //에러 발견시, 콜백

            });
        } else {
            //작으면 (즉, 메뉴를 다시 들은 경우) 아무것도 안함
            //console.log("메뉴 복습 중으로, menu_no Update 안함");
        }
    }).catch(err => {
        //console.log("에러 발견", err);
        //메뉴 넘버 업데이트 실패
    }).then(() => {
        //에러 발견시, 콜백

    });

};



const shuffleArr = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};

const trimStr = (str) => { //알파벳과 숫자를 제외한 모든 문자 및 공백 제거 후 대문자로 치환
    return str.replace(/[^(a-zA-Z|0-9)]/gi, '').toUpperCase();
};

const trimStrForUpload = (str) => { //특수 문자 제거. ' > ´ 치환

    return str.replace(/'/g,'´').replace(/[{}[\]/,;:|)*~^\-_+<>@#$%&\\=(]/gi, '');
};

const trimStrForUpload2 = (str) => { // //특수 문자 제거 |,는 제거 안함.
    return str.replace(/'/g,'´').replace(/[{}[\]/;:)*~^\-_+<>@#$%&\\=(]/gi, '');
};


const capitalize = (str) => {
    if(typeof str !== "string"){
        //console.log("입력값이 String Type이 아닙니다.");
        return null;
    }

    return str.charAt(0).toUpperCase() + str.slice(1);

}

//sort by c_code_no and content_seq
const _sort = (contents) => {
    return contents.sort((a,b) => {
        if(a.c_code_no === "" || a.c_code_no === " ") {
            if(a.content_seq < b.content_seq) {
                return -1;
            } else if(a.content_seq > b.content_seq){
                return 1;
            } else {
                return 0;
            }
        } else if(parseInt(a.c_code_no) < parseInt(b.c_code_no)) {
            return -1;
        } else if(parseInt(a.c_code_no) > parseInt(b.c_code_no)) {
            return 1;
        } else { //c_code_no 가 같은 경우 content_seq 로 정렬
            if(a.content_seq < b.content_seq) {
                return -1;
            } else if(a.content_seq > b.content_seq){
                return 1;
            } else {
                return 0;
            }
        }
    })
}

// src mp3 to opus 
const _parseMp3ToOpus = (src) => {
    
    if (!src) return src;
    // Replace only a final ".mp3" (optionally followed by ?query or #hash)
    return src.replace(/\.mp3(?=($|[?#]))/i, ".opus");
};


const _parseOpusToMp3 = (src) => {
    if (!src) return src;
    return src.replace(/\.opus(?=($|[?#]))/i, ".mp3");
};

export {
    getCurrentMenuInfo,
    brTagActivator,
    calculateScore,
    getABCScore,
    getStorytellingABCScore,
    isShortSpeechOriginal,
    brTagRemover,
    getTodayDate,
    uploadScore,
    uploadScoreAl,
    uploadAnswerAl,
    isMobile,
    isIOS,
    //reportEndLesson,
    updateStdLesson,
    updateMenuNo,
    FailScore,
    strongTagChanger,
    shuffleArr,
    trimStr,
    capitalize,
    trimStrForUpload,
    trimStrForUpload2,
    _sort,
    retouchResultNumber,
    _parseMp3ToOpus,
    _parseOpusToMp3
}
